import {GetVersionInfo} from '@/api/system'

const state = {
    value: 'ws://www.admin.ryiw.vip:8274'
}

const mutations = {
    SET_VALUE(state, data) {
        //console.log(data)
        state.value = data
    }
}

const actions = {
    init({commit}) {
        return new Promise((resolve, reject) => {
            // GetVersionInfo({app_type: "1", app_source: "3", version: "1.0"})
            //     .then(response => {
            //
            //         //const { code, msg, data } = response
            //         if (response.data.code * 1 === 0) {
            //             const {version_info} = response.data.data
            //             //version_info.im_socket_url = version_info.im_socket_url.replace('http', 'ws')
            //             version_info.im_socket_url = version_info.im_socket_url.replace('http', 'ws');
            //             //console.log(version_info.im_socket_url);
            //             //console.log(version_info);
            //             commit('SET_VALUE', version_info.im_socket_url)
            //
            //         }
            //         resolve()
            //     })
            //     .catch(error => {
            //         reject(error)
            //     })
        })
    },
    clear({dispatch}) {
        // 关闭WebSocket链接
        dispatch('websocket/close', null, {root: true})
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
